import { render, staticRenderFns } from "./CancelRegistration.vue?vue&type=template&id=4d0652b2"
import script from "./CancelRegistration.vue?vue&type=script&lang=js"
export * from "./CancelRegistration.vue?vue&type=script&lang=js"
import style0 from "./CancelRegistration.vue?vue&type=style&index=0&id=4d0652b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports